import React, { useEffect, useRef } from "react";
import Banner from "./components/banner/Banner";
import Contact from "./components/contact/Contact";
import Features from "./components/features/Features";
import Footer from "./components/footer/Footer";
import FooterBottom from "./components/footer/FooterBottom";
import Navbar from "./components/navbar/Navbar";
import Projects from "./components/projects/Projects";
import Resume from "./components/resume/Resume";
import Testimonial from "./components/tesimonial/Testimonial";
import Certificate from "./components/certificates/Certificate";

function App() {
  const glowRef = useRef(null);

  useEffect(() => {
    const el = glowRef.current;
    if (!el) return;

    const onMove = (e) => {
      el.style.left = `${e.clientX}px`;
      el.style.top = `${e.clientY}px`;
    };

    window.addEventListener("pointermove", onMove, { passive: true });
    return () => window.removeEventListener("pointermove", onMove);
  }, []);

  return (
    <div className="agi-canvas max-w-full h-auto px-4 relative overflow-x-hidden">
      <div className="agi-dot-grid" aria-hidden="true" />
      <div ref={glowRef} className="agi-pointer-glow hidden md:block" aria-hidden="true" />

      <div className="relative z-10">
        <Navbar />
        <div className="max-w-screen-xl mx-auto">
          <Banner />
          <Features />
          <Projects />
          <Resume />
          <Testimonial />
          <Certificate />
          <Contact />
          <Footer />
          <FooterBottom />
        </div>
      </div>
    </div>
  );
}

export default App;
